export default __webpack_public_path__ + "static/media/ico_timer.6647ae85.svg";